module.exports = __webpack_public_path__ + "media/Whoosh_Low_Fast_Raxr_Edos_4.3f137e4e.mp3";